// Public account-deletion page. MUST stay a single top-level segment with no
// trailing slash: vite builds with base "./" (the desktop file:// renderer
// needs it), so asset URLs resolve against the document URL and any deeper
// path would 404 them. __root.tsx renders this route without AuthGuard.

import { createFileRoute } from '@tanstack/react-router';

import { DeleteAccountPage } from '../components/account/DeleteAccountPage';

interface DeleteAccountSearch {
    deleted?: '1';
    token?: string;
}

export const Route = createFileRoute('/delete-account')({
    validateSearch: (raw: Record<string, unknown>): DeleteAccountSearch => {
        const out: DeleteAccountSearch = {};
        if (raw.deleted === '1' || raw.deleted === 1) out.deleted = '1';
        if (typeof raw.token === 'string' && raw.token) out.token = raw.token;
        return out;
    },
    component: DeleteAccountPage,
});
